import {
  SearchVolumeEstimation,
  SearchWarmupParams,
} from "@radarly/api/warmups";
import { Historicals } from "@radarly/models/historical";
import { Post } from "@radarly/models/posts";
import { SearchData, SearchParams } from "@radarly/models/search";

export interface WarmupRepository {
  searchHistorical(params: SearchWarmupParams): Promise<{
    hits: Post[];
    took: number;
    total: number;
  }>;
  searchFragmentData<T extends SearchData>(
    project: number,
    query: SearchParams
  ): Promise<T>;
  retrieveData(
    projectId: number,
    params: SearchWarmupParams
  ): Promise<{
    expected: number;
    warmupId: number;
  }>;
  getHistoricals(projectId: number): Promise<Historicals>;
  getHistoricalEstimation(
    projectId: number,
    params: SearchWarmupParams
  ): Promise<SearchVolumeEstimation>;
}

export const WarmupRepositoryUID = Symbol("Radarly/WarmupRepository");
